<template>
  <div id="cart">
    <div class="cart_content">
      <div class="cart_info" v-if="totalNum">
        <h2>购物车</h2>
        <div class="p_number">
          <div class="p_number_left">
            <p>房号:{{ roomno }}</p>
            <p>
              手机号:
              <!--<span v-if="!peopleList.p_mark">无</span>
              <span v-if="peopleList.p_mark">{{ peopleList.p_mark }}</span>-->
              <span v-if="!p_mark">无</span>
              <span v-if="p_mark">{{ p_mark }}</span>
            </p>
          </div>
          <div class="p_number_right">
            <router-link to="/editpeopleinfo" tag="p">
              <img src="../assets/images/edit.png" />
              <p>修改</p>
            </router-link>
          </div>
        </div>

        <div class="cart_p_num">
          <p>购物车中总共有{{ totalNum }}个商品</p>

          <p>
            合计：
            <span class="price">¥{{ allPrice }}</span>
          </p>
        </div>
      </div>

      <div class="cart_list" v-if="totalNum">
        <ul>
          <li class="item" v-for="(item,key) in list">
            <div class="left_food">
              <img :src="api + item.img_url" />
              <!--此处不能用长度来比较,因为获取不到长度<p v-if="item.cool.length>0">{{ item.title }}/{{ item.cool }}</p>-->
              <div class="food_info">
                <p v-if="item.cool">{{ item.title }}/{{ item.cool }}</p>
                <p v-if="!item.cool">{{ item.title }}</p>
                <p class="price">¥{{ item.price }}</p>
              </div>
            </div>

            <div id="right_cart">
              <div class="cart_num">
                <div class="input_left" @click="decNum(item, key)">-</div>
                <div class="input_center"><input type="text" readonly="readonly" v-model="item.num" name="num" id="num" /></div>
                <div class="input_right" @click="incNum(item)">+</div>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div class="hot_food">
        <h3>本店顾客最常点的商品</h3>

        <div class="item_list_outer">
          <ul class="item_list">
            <li v-for="food in listMenu">
              <div class="inner">
                <router-link :to="'/pcontent?id=' + food._id">
                  <img :src="api + food.img_url" />
                  <p class="title">{{ food.title }}</p>
                  <p class="price">¥{{ food.price }}</p>
                </router-link>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div v-if="!totalNum" class="cart_empty">您的购物车空空的，点击菜单下单</div>
    </div>

    <v-navfooter></v-navfooter>

    <div id="footer_book" class="footer_book">
      <router-link to="/home">
        <img src="../assets/images/menu.png" />
        <p>菜单</p>
      </router-link>
    </div>

    <div @click="addOrder()" id="footer_cart" class="footer_cart">
      <img src="../assets/images/doorder.png" />
      <p>下单</p>
    </div>
  </div>
</template>

<script>
  //引入NavFooter组件
  import NavFooter from './public/NavFooter.vue';

  //引入配置文件

  import Config from '../model/config.js';

  import storage from '../model/storage.js';

  export default {
    data() {
      return {
        api: Config.api,
        list: [],
        peopleList: [],
        allPrice: 0,
        totalNum: 0,
        listMenu: [],
        roomno: '', //szy add
        p_mark: '', //手机号或别的字符
      };
    },
    sockets: {
      addcart: function() {
        /*接受服务器广播过来的addcart*/
        //更新购物车的数据
        this.getCartData();
      }
    },
    methods: {
      getCartData() {
        //桌子id  桌子号：是扫描二维码从url获取的

        var uid = storage.get('roomid');

        var api = this.api + 'api/cartlist?uid=' + uid;

        this.$http.get(api).then(
          response => {
            // console.log(response);

            this.list = response.body.result;

            this.getTotalResult();
          },
          error => {
            console.log(error);
          }
        );
      },
      decNum(item, key) {
        var uid = String(storage.get('roomid'));

        //请求远程服务器执行更新操作
        //桌子id  桌子号：是扫描二维码从url获取的
        var product_id = item.product_id;
        var num = item.num;
        var api = this.api + 'api/decCart?uid=' + uid + '&product_id=' + product_id + '&num=' + num;

        this.$http.get(api).then(
          response => {
            //修改购物车数据的时候给服务器发消息
            this.$socket.emit('addcart', 'addcart');

            this.getTotalResult();
          },
          error => {
            console.log(error);
          }
        );

        if (item.num == 1) {
          //删除当前购物车的这条数据
          this.list.splice(key, 1); //移除list中的ID=key的一条记录szy add
        } else {
          --item.num;
        }
      },
      incNum(item) {
        // incCart?uid=a001&product_id=1241241255436246&num=2
        //请求远程服务器执行更新操作
        var uid = String(storage.get('roomid'));
        //数据类型在GET或POST之前就要固定好，因为后台直接Data整体插入，MONGODB有致命性的缺点：默认全数字，当数值保存，
        //，导致查询不到，原因为类型不一致。困扰了好几天的原因找到了。

        //桌子id  桌子号：是扫描二维码从url获取的
        var product_id = item.product_id;
        var num = item.num;
        var api = this.api + 'api/incCart?uid=' + uid + '&product_id=' + product_id + '&num=' + num;

        this.$http.get(api).then(
          response => {
            //修改购物车数据的时候给服务器发消息
            this.$socket.emit('addcart', 'addcart');

            this.getTotalResult();
          },
          error => {
            console.log(error);
          }
        );

        ++item.num;
      },
      /*获取总数量 以及总价格*/
      getTotalResult() {
        var allPrice = 0;
        var totalNum = 0;

        for (var i = 0; i < this.list.length; i++) {
          allPrice += parseFloat(this.list[i].price * this.list[i].num);

          totalNum += this.list[i].num;
        }

        this.allPrice = allPrice;

        this.totalNum = totalNum;
      },
      //获取用餐人的信息

      getPeopleInfoList() {
        var uid = String(storage.get('roomid')); //szy add

        this.roomno = uid; //szy add

        this.p_mark = String(storage.get(uid)); //szy add,本地取

        /*var api = this.api + 'api/peopleInfoList?uid=' + uid;

        this.$http.get(api).then(
          response => {
            console.log(response);
            this.peopleList = response.body.result[0];
          },
          response => {
            // error callback
          }
        );*/ //szy mod
      },
      addOrder() {
        //提交订单
        var uid = String(storage.get('roomid'));
        //var p_num = this.peopleList.p_num;//szy mod

        var p_num = '1';

        //var p_mark = this.peopleList.p_mark;//szy mod
        var p_mark = String(this.p_mark); //取本地的,szy add

        var total_price = this.allPrice;
        var total_num = this.totalNum;
        var order = JSON.stringify(this.list); /*数组   把json对象转化成json字符串*/

        var api = this.api + 'api/addOrder';

        if (total_num == 0) { //szy add,不支持跳出
          alert('购物车为空，请先点单');
        } else {

          this.$http
            .post(api, {
              uid,
              p_num,
              p_mark,
              total_price,
              total_num,
              order
            })
            .then(
              response => {
                if (response.body.success) {
                  this.$router.push({
                    path: 'order'
                  });

                  //修改购物车数据的时候给服务器发消息  szy add
                  this.$socket.emit('addcart', 'addcart');

                  //storage.remove(uid);//szy add
                }
              },
              err => {
                console.log(err);
                alert('下单失败，手机号不正确');
              }
            );
        }
      },
      //szy add 购物车脚部的：最常点菜
      getMenu() {
        var api = this.api + 'api/productlistone';
        //this  要注意指向
        this.$http.get(api).then(
          response => {
            console.log(response);

            this.listMenu = response.body.result;
          },
          response => {
            // error callback
          }
        );
      }
    },
    mounted() { //网页渲染前执行此代码？待查
      this.getCartData();
      this.getPeopleInfoList();
      this.getMenu() //加载最常点的菜
    },

    components: {
      'v-navfooter': NavFooter
    }
  };
</script>

<style lang="scss">
  .cart_content {
    padding: 1rem;

    /*头部信息*/
    .cart_info {
      background: #fff;

      h2 {
        text-align: center;
        font-size: 1.8rem;
        padding: 0.8rem 0px;
        border-bottom: 1px solid #eee;
      }

      border-radius: 0.5rem;
      padding: 0.5rem;

      .p_number {
        display: flex;

        padding: 0.5rem 0;
        border-bottom: 1px solid #eee;

        .p_number_left {
          flex: 1;

          p {
            line-height: 2;

            font-size: 2rem;

            &:first-child {
              color: red;
            }
          }
        }

        .p_number_right {
          width: 4rem;
          height: 4rem;
          text-align: center;

          font-size: 2rem;

          img {
            width: 1.8rem;
            height: 1.8rem;
            margin: 0 auto;
          }
        }
      }

      /*购物车总数量*/

      .cart_p_num {
        border-bottom: 1px solid #eee;

        p {
          line-height: 2;

          .price {
            font-size: 2.4rem;
            color: red;
          }
        }
      }
    }

    /*购物车列表*/

    .cart_list {
      margin-top: 1rem;

      padding: 0.5rem;

      background: #fff;

      border-radius: 0.5rem;

      display: flex;

      ul {
        width: 100%;

        .item {
          display: flex;
          width: 100%;

          border-bottom: 1px solid #eee;

          padding: 1rem 0px;

          .left_food {
            flex: 1;

            display: flex;

            img {
              width: 4rem;
              height: 4rem;
              border-radius: 10%;
              margin-right: 0.8rem;
            }

            .food_info {
              flex: 1;
              font-size: 2rem;
            }
          }

          .right_cart {
            width: 10rem;
            font-size: 2rem;
          }
        }
      }
    }

    /*最长点的菜*/

    .hot_food {
      background: #fff;

      margin-top: 1rem;

      border-radius: 0.5rem;

      margin-bottom: 4rem;

      h3 {
        font-size: 1.4rem;

        padding: 0.5rem 0px;
      }

      .item_list_outer {
        width: 100%;

        overflow-x: auto;

        .item_list {
          padding: 0px 0.5rem;
          width: 50rem;

          li {
            width: 8rem;
            padding: 0.5rem;
            box-sizing: border-box;
            float: left;

            .inner {
              background: #fff;
              width: 100%;
              border-radius: 0.5rem;
              overflow: hidden;

              img {
                width: 100%;
              }
            }
          }
        }
      }
    }
  }

  /*购车加减*/
  .cart_num {
    width: 10rem;

    display: flex;
    margin-top: 0.8rem;

    .input_left,
    .input_right {
      flex: 1;

      width: 2.8rem;
      height: 2.8rem;

      line-height: 2.8rem;

      text-align: center;

      color: red;

      border: 1px solid #eee;

      font-size: 2.4rem;
    }

    .input_center {
      flex: 1;

      input {
        width: 2rem;
        text-align: center;
        width: 100%;
        height: 2.8rem;
        border: none;

        border-top: 1px solid #eee;

        border-bottom: 1px solid #eee;

        float: left;
      }
    }
  }

  /*购车空*/

  .cart_empty {
    text-align: center;
    line-height: 3;

    font-size: 2rem;

    h3 {
      font-size: 1.8rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Cart.vue